import { Box, Chip, FormControl, FormHelperText, IconButton, MenuItem, Select, SelectChangeEvent, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from "@mui/material";
import { DropdownModel, NLCInfo, EditorType, SplitMenuItem } from "../../data/interfaces/sharedmodels";
import { useAppSelector, useAppDispatch } from "../../stores/hooks";
import { OpenInFullSharp as OpenInFullSharpIcon, CloseFullscreenSharp as CloseFullscreenSharpIcon } from '@mui/icons-material';
import {
    updateDatatableExpanded as magneticupdateDatatableExpanded,
    updateVersion as updateMagneticVersion, updateselectedNlcs, updateEditorType as magneticUpdateEditorType, updateFilterAtts as updateMagneticFilterAtts, updateEditorType
} from "../../stores/magneticslice";
import {
    updateDatatableExpanded as itsoupdateDatatableExpanded, updateVersion as updateItsoVersion
    , updateEditorType as itsoUpdateEditorType, updateFilterAtts as updateItsoFilterAtts
} from "../../stores/itsoslice";
import { IsEditedContext } from "../../../App";
import ConfirmDialog from "../confirmdialog";
import { useContext, useState } from "react";


export default function DataTableHeader({ heading, parent, versions }: { heading: string | undefined, parent: string, versions: DropdownModel[] }){
    const [confirmDialogOpen, setConfirmDialogOpen] = useState<boolean>(false);
    const [pendingVersion, setPendingVersion] = useState<string | null>(null);
    const { isEdited, setIsEdited } = useContext(IsEditedContext);
    const tablexpanded = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.datatableExpanded; }
        else { return state.itsoReducer.datatableExpanded; }
    });
    const selectedNlcs = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedNlcs; }
        else { return state.itsoReducer.selectedNlcs; }
    });

    const selectedVersion = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedVersion; }
        else { return state.itsoReducer.selectedVersion; }
    });
    const selectedTable = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.selectedDataTable; }
        else { return state.itsoReducer.selectedDataTable; }
    });
    const editorType = useAppSelector((state) => {
        if (parent === 'magnetic') { return state.magneticReducer.editorType; }
        else { return state.itsoReducer.editorType; }
    });
    const dispatch = useAppDispatch();
    const handlePdfExport = () => {
        alert('pdf');
    };
    const handleExcelExport = () => {
        alert('Excel');
    };
    const handleExpand = () => {
        if (parent === 'magnetic') {
            dispatch(magneticupdateDatatableExpanded(!tablexpanded));
        }
        else {
            dispatch(itsoupdateDatatableExpanded(!tablexpanded));
        }
    }
    const handleDelete = (nlc: NLCInfo) => () => {
        const currentIndex = selectedNlcs.findIndex(a => a.NLC == nlc.NLC);
        const newChecked = [...selectedNlcs];

        if (currentIndex != -1) {
            newChecked.splice(currentIndex, 1);
        }

        dispatch(updateselectedNlcs(newChecked));
    };
    // const handleVersionChange = (event: SelectChangeEvent<string | null>) => {
    //     debugger;
    //     if (parent === 'magnetic') {
    //         dispatch(updateMagneticVersion(event.target.value));
    //     }
    //     else {
    //         dispatch(updateItsoVersion(event.target.value));
    //     }
    // }

    const handleVersionChange = (event: SelectChangeEvent<string | null>) => {
        
        if (isEdited) {
           
          setConfirmDialogOpen(true); 
          setPendingVersion(event.target.value); 
        } else {
          dispatch(parent === "magnetic" ?  updateMagneticVersion(event.target.value): updateItsoVersion(event.target.value));
        }
      };


      const handleDialogCallback = (confirmed: boolean) => {
        setConfirmDialogOpen(false);
       
        if (!confirmed && pendingVersion) {
            setIsEdited(false);
          dispatch(parent === "magnetic" ?  updateMagneticVersion(pendingVersion): updateItsoVersion(pendingVersion));
        }
        setPendingVersion(null); 
      };


    const handleChange = (
        event: React.MouseEvent<HTMLElement>,
        newEditorType: EditorType,
    ) => {
        if (parent === 'magnetic') {
            dispatch(magneticUpdateEditorType(newEditorType));
        }
        else {
            dispatch(itsoUpdateEditorType(newEditorType));
        }
    };
    const menus: SplitMenuItem[] = [{ Description: 'As PDF', CallBackFn: { handlePdfExport } },
    { Description: 'As Excel', CallBackFn: { handleExcelExport } }]
    return (
        <Box sx={{ display: 'inline-block', width: '100%' }}>
             <ConfirmDialog
        isopen={confirmDialogOpen}
        title="Unsaved Changes"
        message="Are you sure you want to continue? Any unsaved changes will be lost."
        needComments={false}
        callback={handleDialogCallback}
        yesButtonText="Stay and Save"
        cancelButtonText="Continue"
      />
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography variant="h6">{heading ?? 'Please select a table to see the data.'}</Typography>
                {selectedTable?.IsGlobal?null: selectedNlcs.map((nlc) => {
                return (
                    <Chip key={nlc.NLC} label={nlc.StationName} onDelete={handleDelete(nlc)} />
                )
            })

            }
                {selectedTable?.EditorType == EditorType.TableOrForm ?
                    <ToggleButtonGroup sx={{ height: 30 }} size="small" color='primary' value={editorType} exclusive onChange={handleChange}>
                        <ToggleButton value={EditorType.Table}>Table</ToggleButton>
                        <ToggleButton value={EditorType.Form}>Form</ToggleButton>
                    </ToggleButtonGroup> : null}
                {heading == undefined ? '' : <Box component='div' sx={{ display: 'inline-flex' }}>
                    {versions.length > 0 ? <FormControl>
                        <Select labelId="select-version-label" aria-label="Select version to view data" size="small" value={selectedVersion??''} onChange={handleVersionChange}>
                            {versions.map((version) => {
                                return (
                                    <MenuItem key={version.Id} value={version.Id}>{version.Description}</MenuItem>
                                )
                            })}
                        </Select>
                        <FormHelperText>Select a version to view data</FormHelperText>
                    </FormControl> : null}
                    <Tooltip  title={tablexpanded?'Collpase':'Expand'}>
                    <IconButton sx={{ ml: 1 }} onClick={handleExpand}>
                        {!tablexpanded ? <OpenInFullSharpIcon />
                            : <CloseFullscreenSharpIcon />}
                    </IconButton>
                    </Tooltip>
                </Box>}
            </Box>
                            
        </Box>
    )
}